import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-left flex min-w-0 w-full flex-col overflow-hidden rounded-3xl border border-slate-100 bg-white shadow-sm p-6 md:p-8 space-y-6" }
const _hoisted_2 = { class: "flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-slate-100/70 pb-4" }
const _hoisted_3 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_4 = {
  key: 1,
  class: "border border-dashed border-slate-200 bg-slate-50/40 p-10 rounded-2xl text-center space-y-3"
}
const _hoisted_5 = { class: "size-12 rounded-2xl bg-slate-100 text-slate-400 flex items-center justify-center mx-auto" }
const _hoisted_6 = {
  key: 2,
  class: "space-y-6"
}
const _hoisted_7 = { class: "rounded-2xl border border-blue-100/80 bg-gradient-to-r from-blue-50/40 via-white to-white p-6 md:p-7 shadow-xs flex flex-col md:flex-row md:items-center justify-between gap-6" }
const _hoisted_8 = { class: "space-y-3 flex-1 min-w-0" }
const _hoisted_9 = { class: "flex flex-wrap items-center gap-2.5" }
const _hoisted_10 = { class: "inline-flex items-center gap-1.5 px-3 py-0.5 rounded-full bg-blue-100/70 text-[#1f7aff] text-xs font-black" }
const _hoisted_11 = { class: "text-xs font-semibold text-slate-400" }
const _hoisted_12 = { class: "text-lg md:text-xl font-black text-slate-900 tracking-tight" }
const _hoisted_13 = { class: "text-xs md:text-sm text-slate-600 font-medium mt-1 leading-relaxed" }
const _hoisted_14 = { class: "flex flex-wrap items-center gap-2.5 shrink-0" }
const _hoisted_15 = {
  key: 0,
  class: "border-t border-slate-100 pt-4 space-y-3"
}
const _hoisted_16 = { class: "divide-y divide-slate-100" }
const _hoisted_17 = { class: "min-w-0 flex items-center gap-3" }
const _hoisted_18 = { class: "size-9 rounded-xl bg-slate-100 flex items-center justify-center shrink-0" }
const _hoisted_19 = { class: "min-w-0" }
const _hoisted_20 = { class: "text-sm font-bold text-slate-800 truncate" }
const _hoisted_21 = { class: "text-xs text-slate-400 font-medium" }
const _hoisted_22 = { class: "flex items-center gap-2 shrink-0" }

import { ref, computed } from "vue";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import DMSuiteIcon from "@/components/iconify/DMSuiteIcon.vue";
import { DASHBOARD_ICONS } from "@/config/dashboardIcons";
import ReportDownloadPreviewModal from "./ReportDownloadPreviewModal.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'MonthlyReportsPanel',
  props: {
    reports: {},
    loading: { type: Boolean }
  },
  emits: ["download", "preview"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const selectedReport = ref<any>(null);
const showPreviewModal = ref(false);

const publishedReports = computed(() => {
  if (!Array.isArray(props.reports)) return [];
  return props.reports;
});

const latestReport = computed(() => {
  return publishedReports.value.length > 0 ? publishedReports.value[0] : null;
});

const olderReports = computed(() => {
  return publishedReports.value.slice(1, 4);
});

function handleDownloadClick(report: any) {
  selectedReport.value = report;
  showPreviewModal.value = true;
}

function handleConfirmDownload() {
  if (selectedReport.value) {
    emit("download", selectedReport.value);
  }
  showPreviewModal.value = false;
}

function formatDate(value?: string | null) {
  if (!value) return "Published recently";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Published recently";
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", null, [
        _createElementVNode("h3", { class: "font-black text-slate-900 text-xl md:text-2xl" }, " Latest Progress Report "),
        _createElementVNode("p", { class: "font-semibold text-sm md:text-base text-slate-600 mt-1" }, " Review your marketing performance analytics and campaign highlights. ")
      ], -1)),
      (latestReport.value)
        ? (_openBlock(), _createBlock(_unref(Badge), {
            key: 0,
            variant: "outline",
            class: "bg-emerald-50 text-emerald-700 border-emerald-200/80 font-bold px-3 py-1 rounded-full text-xs self-start sm:self-center"
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode(" Latest Available Report ", -1)
            ]))]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (__props.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_unref(Skeleton), { class: "h-36 rounded-2xl bg-slate-100 animate-pulse" })
        ]))
      : (!latestReport.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(DMSuiteIcon, {
                icon: _unref(DASHBOARD_ICONS).eventReport,
                size: 24,
                "custom-class": "text-slate-400"
              }, null, 8, ["icon"])
            ]),
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "space-y-1" }, [
              _createElementVNode("p", { class: "text-base font-bold text-slate-800" }, " No reports published yet "),
              _createElementVNode("p", { class: "text-xs text-slate-400 font-medium max-w-sm mx-auto" }, " Your published monthly progress reports will appear here as soon as they are compiled and finalized by your team. ")
            ], -1))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, [
                    _createVNode(DMSuiteIcon, {
                      icon: _unref(DASHBOARD_ICONS).calendar,
                      size: 13
                    }, null, 8, ["icon"]),
                    _createTextVNode(" " + _toDisplayString(latestReport.value.report_period || 'Monthly Summary'), 1)
                  ]),
                  _createElementVNode("span", _hoisted_11, " Published on " + _toDisplayString(formatDate(latestReport.value.created_at)), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("h4", _hoisted_12, _toDisplayString(latestReport.value.title || 'Digital Marketing Performance Report'), 1),
                  _createElementVNode("p", _hoisted_13, _toDisplayString(latestReport.value.summary || latestReport.value.description || 'Comprehensive evaluation of campaign reach, active service deliverables, audience interactions, and progress milestones.'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_unref(Button), {
                  size: "sm",
                  variant: "outline",
                  class: "border-slate-200 bg-white hover:bg-slate-50 text-slate-700 font-bold rounded-xl h-10 px-4 text-xs md:text-sm shadow-xs flex items-center gap-2 transition-all",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('preview', latestReport.value)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(DMSuiteIcon, {
                      icon: _unref(DASHBOARD_ICONS).preview,
                      size: 16,
                      "custom-class": "text-[#1f7aff]"
                    }, null, 8, ["icon"]),
                    _cache[6] || (_cache[6] = _createTextVNode(" View Report ", -1))
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Button), {
                  size: "sm",
                  class: "bg-[#1f7aff] hover:bg-[#185adb] text-white font-bold rounded-xl h-10 px-4 text-xs md:text-sm shadow-xs flex items-center gap-2 transition-all",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (handleDownloadClick(latestReport.value)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(DMSuiteIcon, {
                      icon: _unref(DASHBOARD_ICONS).download,
                      size: 16
                    }, null, 8, ["icon"]),
                    _cache[7] || (_cache[7] = _createTextVNode(" Download PDF ", -1))
                  ]),
                  _: 1
                })
              ])
            ]),
            (olderReports.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _cache[10] || (_cache[10] = _createElementVNode("h5", { class: "text-xs font-extrabold text-slate-400 uppercase tracking-wider" }, " Previous Reports ", -1)),
                  _createElementVNode("div", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(olderReports.value, (report) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: report.id,
                        class: "py-3 flex items-center justify-between gap-4"
                      }, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createVNode(DMSuiteIcon, {
                              icon: _unref(DASHBOARD_ICONS).eventReport,
                              size: 16,
                              "custom-class": "text-slate-500"
                            }, null, 8, ["icon"])
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("p", _hoisted_20, _toDisplayString(report.title), 1),
                            _createElementVNode("p", _hoisted_21, _toDisplayString(report.report_period) + " • " + _toDisplayString(formatDate(report.created_at)), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_unref(Button), {
                            size: "sm",
                            variant: "ghost",
                            class: "text-xs font-bold text-[#1f7aff] hover:bg-blue-50/50 h-8 px-2.5 rounded-lg",
                            onClick: ($event: any) => (_ctx.$emit('preview', report))
                          }, {
                            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                              _createTextVNode(" View ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_unref(Button), {
                            size: "sm",
                            variant: "ghost",
                            class: "text-xs font-bold text-slate-600 hover:bg-slate-100 h-8 px-2.5 rounded-lg",
                            onClick: ($event: any) => (handleDownloadClick(report))
                          }, {
                            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                              _createTextVNode(" PDF ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ])),
    _createVNode(ReportDownloadPreviewModal, {
      open: showPreviewModal.value,
      "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => ((showPreviewModal).value = $event)),
      report: selectedReport.value,
      onConfirmDownload: handleConfirmDownload
    }, null, 8, ["open", "report"])
  ]))
}
}

})